/**
 * How the Suggestion Engine opens (owner, 15 Oct 2026).
 *
 * The first time a scenario is modelled — or whenever a new one is run — the engine shows its
 * "thinking" screen for at least {@link THINKING_FLOOR_MS}: it really is simulating hundreds of
 * options, and showing that work is part of the experience. Re-opening a plan that was already
 * modelled and saved is different: the adviser just wants it back on screen, so the floor is nil and
 * a quiet "opening your saved plan" note stands in for the illustration while the figures are rebuilt.
 *
 * The decision is taken ONCE, when the panel mounts; after the first run completes the panel is back
 * on the thinking opening, so a re-run with new settings or a new horizon still shows the work.
 */
export type EngineOpening = 'thinking' | 'quiet';

export const THINKING_FLOOR_MS = 3500;

export function engineOpening(input: { reopenedSavedStrategyId?: string | null }): EngineOpening {
    return input.reopenedSavedStrategyId ? 'quiet' : 'thinking';
}

export function loaderFloorMs(opening: EngineOpening): number {
    return opening === 'quiet' ? 0 : THINKING_FLOOR_MS;
}

/** How much longer the loader stays up once the run has finished. */
export function remainingFloorMs(opening: EngineOpening, startedAt: number, now: number): number {
    return Math.max(0, loaderFloorMs(opening) - (now - startedAt));
}
